module.exports = __webpack_public_path__ + "static/the-quiet-american-208b98ff0938711df90eef0b528db44d.jpg";